import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const links = [
    { label: 'Features',   href: '/#features'   },
    { label: 'WebOns',     href: '/#webons'     },
    { label: 'Developers', href: '/#build'      },
    { label: 'FAQ',        href: '/#faq'        },
    { label: 'Investors',  href: '/investors'   },
  ];

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container navbar__inner">
          <a href="/#hero" className="navbar__logo" aria-label="NOMO">
            <img src="/landing/logos/nomo_logo.png" alt="NOMO" className="navbar__logo-img" />
            <span className="navbar__logo-text">NOMO</span>
          </a>

          <ul className="navbar__links" role="list">
            {links.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="navbar__link">{l.label}</a>
              </li>
            ))}
          </ul>

          <a href="/#cta" className="btn btn-primary navbar__cta-btn">
            <span className="btn__store-text">
              <span className="btn__get-nomo">GET NOMO NOW</span>
            </span>
          </a>

          <button
            className={`navbar__burger ${menuOpen ? 'open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(o => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div
        className={`navbar__mobile-menu ${menuOpen ? 'open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <ul role="list">
          {links.map((l) => (
            <li key={l.label}>
              <a href={l.href} className="navbar__link" onClick={close}>{l.label}</a>
            </li>
          ))}
        </ul>
        <a href="/#cta" className="btn btn-outline" onClick={close}>
          <span className="btn__store-text">
            <span className="btn__store-label">Download NOMO</span>
          </span>
        </a>
      </div>
    </>
  );
}
